module.exports = __webpack_public_path__ + "img/demo.748cc208.png";